const FormRecipientsTypeEnum = {
  CONTACT: 0,
  CONTACTS_REPLY: 1,
};

const FormRecipientsTypeLabel = new Map([
  [FormRecipientsTypeEnum.CONTACT, 'Contato'],
  [FormRecipientsTypeEnum.CONTACTS_REPLY, 'Resposta de contatos'],
]);

export { FormRecipientsTypeEnum, FormRecipientsTypeLabel };
